module.exports = __webpack_public_path__ + "static/img/8.19b24c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/01/8.png
// module id = Zhmm
// module chunks = 2